var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMissionDirectoryFunctionDef } from '../../../../backend/features/mission-files/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
const swrCacheKey = 'getMissionDirectory';
export const useMissionFileCurrentDirectory = (missionId) => {
    const getMissionDirectoryPlatformFn = useTypedPlatformFunction(getMissionDirectoryFunctionDef);
    const fetchMissionDirectory = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield getMissionDirectoryPlatformFn({ missionId });
            return res;
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
    });
    const { data, isLoading, error } = useSWR([swrCacheKey, missionId], fetchMissionDirectory, defaultFetcherOptions);
    return {
        currentDirectoryId: data === null || data === void 0 ? void 0 : data.fileId,
        isLoading,
        error,
    };
};
